import { render, staticRenderFns } from "./create-new-user.vue?vue&type=template&id=72504fe3&scoped=true&"
import script from "./create-new-user.vue?vue&type=script&lang=js&"
export * from "./create-new-user.vue?vue&type=script&lang=js&"
import style0 from "./create-new-user.vue?vue&type=style&index=0&id=72504fe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72504fe3",
  null
  
)

export default component.exports